<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Cégcsoport adatai</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'product', company_group ],
				fields: [
					{ type: 'row', fields: [
						{ type: 'col', fields: [
							{ type: 'hidden', name: 'id' },
							{ type: 'fieldset', title: 'Alapadatok', fields: [
								{
									type: 'text',
									name: 'name',
									title: 'Név'
								}
							] }
						]}
					]}
				]
			}) %>
		</div>
		<div class="modal-footer text-end">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async save () {
		const res = await Anvil.exec('company_group/action_save', Anvil.page.modal.company_group)

		// Close modal
		if (res === true) Anvil.page.modal.close()
	}
})
</script>
